var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPositiveVibesIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Positive_Vibes_icon_svg__clip0_2002_335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 770c149.117 0 270-120.883 270-270 0-149.117-120.883-270-270-270-149.117 0-270 120.883-270 270 0 149.117 120.883 270 270 270z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.822 344.262c25.607 0 34.738-34.048 12.464-46.679C580.512 278.44 541.512 267.5 500 267.5s-80.512 10.94-114.286 30.083c-22.273 12.631-13.142 46.679 12.465 46.679h203.643z",
    fill: "#FEDF5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.202 579.524c-32.238 0-63.059-12-86.785-33.81-21.417-19.678-35.393-45.761-39.929-74.19h-48.976c-4.524 28.429-18.5 54.512-39.929 74.19-23.726 21.798-54.547 33.81-86.786 33.81-70.761 0-128.321-57.571-128.321-128.321v-27c0-20.143 16.381-36.524 36.524-36.524h183.595c14.572 0 27.56 8.726 33.333 21.595h52.119c5.786-12.881 18.762-21.595 33.334-21.595h183.595c20.143 0 36.524 16.381 36.524 36.524v27c0 70.761-57.572 128.321-128.322 128.321h.024z",
    fill: "#2A848E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743 397.202c14.916 0 27 12.084 27 27v27C770 516.81 716.809 570 651.202 570c-61.976 0-112.845-47.452-118.309-108h-65.786c-5.452 60.548-56.333 108-118.31 108C283.19 570 230 516.81 230 451.202v-27c0-14.916 12.083-27 27-27h183.595c13.06 0 23.952 9.274 26.464 21.596h65.881c2.5-12.322 13.393-21.596 26.453-21.596h183.595m.012-19.047H559.405c-16.155 0-30.762 8.512-39.012 21.595h-40.786c-8.25-13.095-22.845-21.595-39.012-21.595H257c-25.393 0-46.048 20.655-46.048 46.047v27c0 36.822 14.333 71.441 40.369 97.477 26.036 26.035 60.655 40.369 97.476 40.369 34.631 0 67.75-12.893 93.238-36.322 20.977-19.274 35.31-44.274 41.358-71.678h33.214c6.048 27.416 20.381 52.416 41.357 71.678 25.488 23.417 58.595 36.322 93.238 36.322 36.822 0 71.441-14.334 97.476-40.369 26.036-26.036 40.381-60.655 40.381-97.477v-27c0-25.392-20.654-46.047-46.047-46.047H743z",
    fill: "#006C78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 590c0 33.143-26.857 60-60 60s-60-26.857-60-60",
    stroke: "#FA505E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743 397.202H636.75l-72.798 134.584c21.703 23.488 52.75 38.214 87.25 38.214 1.143 0 2.274-.024 3.405-.048l93.203-172.297a26.65 26.65 0 00-4.81-.453zM436.75 397.202h-60l-85.452 157.976c15.547 8.619 33.226 13.846 52.047 14.703l93.405-172.667v-.012z",
    fill: "#95C2C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Positive_Vibes_icon_svg__clip0_2002_335"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveVibesIcon);
export default ForwardRef;